module.exports = __webpack_public_path__ + "static/images/one.87ab12d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/about/one.png
// module id = 4b2z
// module chunks = 0